import React from 'react';
import { Col } from 'react-bootstrap';
import AutoCarousel from '../../Helpers/Widgets/AutoCarousel/AutoCarousel';
import CircleSection from '../../Helpers/Circles/CircleSection';
import PropTypes from 'prop-types';
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem } from '../../../sessionStorage';

import './Marketing.scss';

function QuoteBlock(props) {
  return (
    <div className="quote-block">
      <Col xs="auto" className="open-quote">“</Col>
      <Col xs="auto" className="quote block-quote">
        <blockquote className="blockquote">
          <p>{props.text}"</p>
          <p>- {props.name}</p>
        </blockquote>
      </Col>
    </div>
  )
}

export default function Marketing(props) {

  const quotes = props.testimonials || [
    {
      name: "Lynn W",
      text: "Thank you for all your help and guidance. You were a pleasure to work with!",
    },
    {
      name: "Nikki G",
      text: "You made it so easy! I can just go to bed at night knowing this was taken care of.",
    },
    {
      name: "Michael G",
      text: "I always avoided life insurance because I just didn't want to spend the money. My family convinced me to look into it, and I bought a policy for far less than I had thought.",
    },
    {
      name: "Joseph A",
      text: "My family moved into our dream home recently and I wanted to make sure they could stay there if something happened to me. It was easy to find insurance and now I know my family's home is safe. Thank you!",
    },
  ];

  const quoteData = quotes.map((d, index) => <QuoteBlock text={d.text} name={d.name} key={index} />);
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  var accountName = accountObj && accountObj.accountDisplayName ? accountObj.accountDisplayName : accountObj && accountObj.account ? accountObj.account.accountName : "Covr";
  const data = [
    {
      image: "home/circle1.png",
      textContent: <div className="text w-100">
        <h2>You can buy TODAY... really!</h2>
        <p>Historically, buying life insurance has been a long, slow, frustrating process. {accountName} is changing that with fast, simple life insurance you can buy online right now. Our application process is streamlined every step of the way and will match you with the best available product, at the best price for you and your family.</p>
      </div>
    },
    {
      image: "home/circle2.png",
      textContent: <div className="quote-carousel w-100">
        <div>
          <h2>What others are saying</h2>
        </div>
        <div className="carousel-wrapper">
          <AutoCarousel showPlayButton={true} data={quoteData} />
        </div>
      </div>
    }
  ]

  return (
    <div className="marketing justify-content-center">
      <CircleSection data={data} reverse />
    </div>
  );
}

Marketing.propTypes = {
  testimonials: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  })),
}



// WEBPACK FOOTER //
// ./src/components/Home/Marketing/Marketing.js